import React from 'react';

import DeliveryFleetRouter from 'bringg-web/features/fleets-configuration/delivery-fleet-router/delivery-fleet-router';
import { Portal } from '../../../components';

export const FleetsRuleListPortal = () => {
	return <Portal element={<DeliveryFleetRouter />} nodeId="fleets-rule-list-portal" />;
};
